import axiosInstance from "../../components/axiosInstance";

export const sendListEmailsRequest = async (data, callbackBefore = () => {}, callbackAfter = () => {}) => {
    callbackBefore();

    return await axiosInstance.get('https://marketplace-api.swierczkacper.pl/api/v1/emails?' + new URLSearchParams(data).toString()).then(function (response) {
        callbackAfter();

        return response;
    }).catch(function (error) {
        callbackAfter();

        return error.response;
    });
}